import { ApiResponse } from '@/types/api.types';
import baseApi from './RootBaseApi';
import { BerthMediationCase, ComparableBerth } from '@/types/berth-mediation.types';

export const MediationService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMediationCases: builder.query<
      ApiResponse<BerthMediationCase[]> & {
        total: number;
        page: number;
        limit: number;
        total_pages: number;
      },
      { harbor_id?: string; status?: string; page?: number; limit?: number }
    >({
      query: (params) => ({
        url: 'mediation-cases',
        method: 'GET',
        params,
      }),
      providesTags: ['Bookings'],
    }),
    getMediationCaseById: builder.query<ApiResponse<BerthMediationCase>, string>({
      query: (id) => ({
        url: `mediation-cases/${id}`,
        method: 'GET',
      }),
      providesTags: ['Bookings'],
    }),
    getComparableBerths: builder.query<ApiResponse<ComparableBerth[]>, string>({
      query: (caseId) => ({
        url: `mediation-cases/${caseId}/comparable-berths`,
        method: 'GET',
      }),
    }),
    proposeReallocation: builder.mutation<
      ApiResponse<BerthMediationCase>,
      { caseId: string; proposed_berth_id: string; reason?: string }
    >({
      query: ({ caseId, ...body }) => ({
        url: `mediation-cases/${caseId}/propose-reallocation`,
        method: 'POST',
        data: body,
      }),
      invalidatesTags: ['Bookings'],
    }),
    resolveExtension: builder.mutation<
      ApiResponse<BerthMediationCase>,
      {
        caseId: string;
        resolution_type: 'decline_extension' | 'offer_alternative';
        boater_a_proposed_berth_id?: string;
        reason?: string;
      }
    >({
      query: ({ caseId, ...body }) => ({
        url: `mediation-cases/${caseId}/resolve-extension`,
        method: 'POST',
        data: body,
      }),
      invalidatesTags: ['Bookings'],
    }),
    cancelMediationCase: builder.mutation<ApiResponse<BerthMediationCase>, string>({
      query: (caseId) => ({
        url: `mediation-cases/${caseId}/cancel`,
        method: 'POST',
      }),
      invalidatesTags: ['Bookings'],
    }),
  }),
});

export const {
  useGetMediationCasesQuery,
  useGetMediationCaseByIdQuery,
  useGetComparableBerthsQuery,
  useProposeReallocationMutation,
  useResolveExtensionMutation,
  useCancelMediationCaseMutation,
} = MediationService;
